/** Design-system units (1 unit = 0.25rem), so the empty card keeps a card-like body. */
export const SALES_LEAGUE_EMPTY_MIN_HEIGHT = 50;
